// Shared seasonality colours + 12-month bar used on tour pages and the map planner.
export const SEASON_COLORS = {
  best: "#0E9E6E",      // green — recommended / actively promoted
  shoulder: "#E8A317",  // amber — available, conditions vary
  blockout: "#D23B24",  // red — no scheduled departures
};
export const SEASON_LABELS = {
  best: "Best",
  shoulder: "Shoulder",
  blockout: "No scheduled departures",
};

function cellBg(primary, secondary) {
  const p = SEASON_COLORS[primary] || "#C9C4BA";
  if (!secondary) return p;
  const s = SEASON_COLORS[secondary] || "#C9C4BA";
  return `linear-gradient(180deg, ${p} 0 50%, ${s} 50% 100%)`;
}

export function SeasonBar({ bar, size = "md", activeMonth = null, className = "" }) {
  if (!bar || !bar.length) return null;
  const h = size === "sm" ? "h-5" : "h-8";
  const labelCls = size === "sm" ? "text-[7px]" : "text-[9px]";
  return (
    <div className={`flex gap-[3px] ${className}`} data-testid="season-bar">
      {bar.map((c) => {
        const on = activeMonth === c.m;
        return (
          <div key={c.m} className="flex-1 flex flex-col items-center gap-1" title={`${c.label}: ${SEASON_LABELS[c.primary]}${c.secondary ? " / " + SEASON_LABELS[c.secondary] : ""}`}>
            <div
              className={`w-full ${h} rounded-[3px] transition-transform ${on ? "ring-2 ring-ink ring-offset-1 scale-[1.06]" : ""}`}
              style={{ background: cellBg(c.primary, c.secondary) }}
              data-testid={`season-cell-${c.m}`}
            />
            <span className={`${labelCls} font-mono uppercase tracking-wide ${on ? "text-ink font-bold" : "text-ink-muted"}`}>{c.label[0]}</span>
          </div>
        );
      })}
    </div>
  );
}

export function SeasonLegend({ className = "" }) {
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1.5 ${className}`} data-testid="season-legend">
      {["best", "shoulder", "blockout"].map((k) => (
        <span key={k} className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wide text-ink-secondary">
          <span className="w-3 h-3 rounded-[2px]" style={{ background: SEASON_COLORS[k] }} /> {SEASON_LABELS[k]}
        </span>
      ))}
    </div>
  );
}
